<template>
  <div class="field-text" v-if="isVisible">
    <select :id="field.form_key" class="custom-select" :tabIndex="question.id" :name="field.form_key" v-model="answer" autocomplete="on"
            :ref="'field_' + field.form_key"  @focus="$emit('questionSelected', question.order)"
    >
      <option selected value="">Please select..</option>
      <option  v-for="(option, index) in field.question_option_tag" :key="index" class="form-control"
      :value="option.value">{{ option.value}}</option>
    </select>
  </div>
</template>

<script>

  import elementMixins from '../mixins/elements'

  export default {
  	name: 'LUSelect',
  	props: [
  		'question',
  		'field',
  		'answers'
  	],
  	mixins: [elementMixins]
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Select.vue